import { SiteControlLayout } from '@scaleaq/sitecontrol-lib';

import type { TemplateWidget } from '@/constants';

export const getTemplateWidgets: (siteControlLayout: SiteControlLayout) => TemplateWidget[] = (
  siteControlLayout: SiteControlLayout
) =>
  siteControlLayout.widgets.reduce((acc: TemplateWidget[], widget) => {
    const templateWidget: TemplateWidget = { x: widget.x, y: widget.y, w: widget.w, h: widget.h };
    acc.push(templateWidget);
    return acc;
  }, []);
